export function createElement(element) {
  return document.createElement(element);
}
